// extracted by mini-css-extract-plugin
export var label = "_ga-2";
export var slideContainer = "_ga-0";
export var slider = "_ga-1";